// El `flux:file-upload` de Flux guarda en el componente el fichero que se suelta
// en la zona de arrastre, pero no lo pone en su `<input type="file">`, que es lo
// único que envía un formulario normal. La consulta llegaba sin la captura
// aunque el cliente la había visto en pantalla debajo de la zona (feedback 271).
// Elegirlo con el diálogo sí funcionaba, porque ahí el fichero ya está en el input.
//
// Con `wire:model` no hace falta: Livewire sube lo que tiene el componente.
export default function syncDroppedFilesIntoNativeForms() {
    document.addEventListener("change", (event) => {
        const upload = event.target;

        if (!(upload instanceof Element) || upload.localName !== "ui-file-upload") return;
        if ([...upload.attributes].some((attribute) => attribute.name.startsWith("wire:model"))) return;

        const input = upload.querySelector('input[type="file"][data-slot="receiver"]');

        if (!input) return;

        const transfer = new DataTransfer();
        (upload.files ?? []).forEach((file) => transfer.items.add(file));
        input.files = transfer.files;
    });
}
